<div class="flex justify-center">
  <div
    class="flex justify-center items-center bg-destructive-50 p-lg rounded-full mb-xl">
    <lib-delete-icon [iconClass]="'size-8 text-destructive-500'" />
  </div>
</div>

<p class="text-lg text-center font-medium mb-sm text-neutral-900">
  {{ 'remove_super_manager_modal_title' | transloco }}
</p>

<p class="text-sm text-neutral-500 text-center mb-4xl">
  {{ 'remove_super_manager_modal_description' | transloco }}
</p>

<div class="flex flex-col gap-md text-base font-medium">
  <button
    (click)="removeAdmin.emit()"
    [class.opacity-30]="isRemoveAdminLoading()"
    [disabled]="isRemoveAdminLoading()"
    class="bg-destructive-500 py-sm rounded-md text-white text-base cursor-pointer">
    {{ 'admin_list_remove_popup_yes_remove_it_button' | transloco }}
  </button>

  <button
    (click)="closeModal.emit()"
    class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
    {{ 'admin_list_remove_popup_no_keep_it_button' | transloco }}
  </button>
</div>
